// Complementary products: variant selection + add to cart
// (Rebuy dependency removed — theme now uses the native /cart page.)

(function () {
  function getProductData(card) {
    var script = card.querySelector('.comp-product-json');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('Invalid product JSON in complementary card', e);
      return null;
    }
  }

  function findVariant(productData, selectedOptions) {
    if (!productData || !productData.variants) return null;

    for (var i = 0; i < productData.variants.length; i++) {
      var variant = productData.variants[i];
      var match = true;
      for (var idx = 0; idx < selectedOptions.length; idx++) {
        var key = 'option' + (idx + 1);
        if (variant[key] !== selectedOptions[idx]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  }

  function setButtonState(form, available) {
    var button = form.querySelector('.add-btn');
    var addText = button.querySelector('.add-text');
    var soldoutText = button.querySelector('.soldout-text');

    if (available) {
      if (addText) addText.style.display = '';
      if (soldoutText) soldoutText.style.display = 'none';
      button.disabled = false;
    } else {
      if (addText) addText.style.display = 'none';
      if (soldoutText) soldoutText.style.display = '';
      button.disabled = true;
    }
  }

  function updateVariant(form) {
   console.log('hiiiii====>>>>',form);
    var card = form.closest('.product-card');
    if (!card) return;

    var productData = getProductData(card);
    if (!productData) return;

    var selects = form.querySelectorAll('.option-select');
    var selectedOptions = [];
    selects.forEach(function (s) {
      selectedOptions.push(s.value);
    });

    // No option selects (default-variant product) — leave the Liquid-rendered state alone.
    if (selectedOptions.length === 0) return;

    var variant = findVariant(productData, selectedOptions);

    if (variant) {
      form.querySelector('.variant-id').value = variant.id;
      setButtonState(form, variant.available);
    } else {
      setButtonState(form, false);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var button = form.querySelector('.add-btn');
    var variantId = form.querySelector('.variant-id').value;

    if (!variantId || button.disabled) return;

    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) { throw err; });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (error) {
        console.error('Error adding to cart:', error);
        button.disabled = false;
      });
  }

  function initCard(card) {
    var form = card.querySelector('form.comp-add-form');
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    form.querySelectorAll('.option-select').forEach(function (select) {
      select.addEventListener('change', function () { updateVariant(form); });
    });

    form.addEventListener('submit', handleSubmit);

    // Sync button state with whatever variant is currently selected.
    updateVariant(form);
  }

  function init() {
    document
      .querySelectorAll('.complementary-products-section-v2 .product-card')
      .forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
